/// <amd-module name="Dashboards/Common/FavoriteProviderDataService" />
import { DashboardFavoriteArtifactProperties } from "Dashboards/Common/Contracts/DashboardFavoriteArtifactProperties";
import { ArtifactProperties, Favorite } from "Favorites/Common/Contracts/Favorite";
import { IFavoriteProviderDataService } from "Favorites/Common/Contracts/Service";
import { Services, VssService } from "VSS/Platform/Context";
import { isFeatureEnabled } from "VSS/Platform/Feature";
import { DisableUserNamePrefixForProjectDashboardFeature } from "./Constants";

class FavoriteProviderDataService extends VssService implements IFavoriteProviderDataService {
    public getArtifactType(): string {
        return "Microsoft.TeamFoundation.Dashboards.Dashboard";
    }

    public getDisplayName({ artifactName, artifactProperties }: Favorite): string {
        if (!this.areDashboardFavoriteProperties(artifactProperties)) {
            return artifactName;
        }

        if (!artifactProperties.groupId && isFeatureEnabled(this.pageContext, DisableUserNamePrefixForProjectDashboardFeature, false)) {
            return artifactName;
        } else {
            return `${artifactProperties.ownerName} - ${artifactName}`;
        }
    }

    private areDashboardFavoriteProperties(artifactProperties: ArtifactProperties): artifactProperties is DashboardFavoriteArtifactProperties {
        return (
            artifactProperties != null &&
            (artifactProperties as DashboardFavoriteArtifactProperties).ownerId != null &&
            (artifactProperties as DashboardFavoriteArtifactProperties).ownerName != null
        );
    }
}

Services.add("dashboard-favorite-provider-data-service", { serviceFactory: FavoriteProviderDataService });
